import { FC } from "react";
import {
  Box,
  Image,
  MantineColorScheme,
  Stack,
  Text,
  Title,
} from "@mantine/core";

import CodeBackground from "@assets/code-background.svg";
import FigmaLogo from "@assets/logos/figma_logo.svg";
import PolicyGeniusLogo from "@assets/logos/policygenius_logo.svg";
import ShopifyLogo from "@assets/logos/shopify_logo.svg";
import SlackLogo from "@assets/logos/slack_logo.svg";
import SnowflakeLogo from "@assets/logos/snowflake_logo.svg";
import VantaLogo from "@assets/logos/vanta_logo.svg";
import OnboardingHeroImg from "@assets/onboarding_hero.png";

import styles from "./ValueProps.module.css";

export const ValueProps: FC<{ colorScheme: MantineColorScheme }> = ({
  colorScheme: _colorScheme,
}) => {
  const backgroundGradientLight =
    "radial-gradient(circle at right bottom, rgb(175 234 216 / 10%), transparent 400px), radial-gradient(10px 20px at 80% top, rgb(194 214 240 / 50%), transparent 50%), #f2f7fa";

  return (
    <Box
      style={{
        position: "relative",
      }}
    >
      {/* Background gradient and container for the code background */}
      <Box className={styles.gradientContainer}>
        {/* Container for the code background */}
        <Box
          w={"100%"}
          bg={backgroundGradientLight}
          className={styles.container}
        >
          <Box>
            <Image src={CodeBackground} />
          </Box>
          <Box>
            <Image src={CodeBackground} />
          </Box>
          <Box>
            <Image src={CodeBackground} />
          </Box>
          <Box>
            <Image src={CodeBackground} />
          </Box>
        </Box>
      </Box>
      {/* Content Box */}
      <Box maw={500} px={20} pb={40} mx="auto">
        <Title order={2}>Get more out of Semgrep</Title>
        <Text c="gray" py={"sm"}>
          Automate, manage and enforce code standards across your organization.
        </Text>
        <Box pb={"md"}>
          <Image src={OnboardingHeroImg} alt="Semgrep Hero Image" />
        </Box>
        <Box>
          <Text c="gray" py={"sm"} tt="uppercase">
            Trusted by top companies
          </Text>
        </Box>
        <Stack py={"sm"} maw={500} gap={32} className={styles.logoStack}>
          <Box>
            <Image src={FigmaLogo} alt="Figma Logo" />
            <Image src={SnowflakeLogo} alt="Snowflake Logo" />
            <Image src={ShopifyLogo} alt="Shopify Logo" />
          </Box>
          <Box>
            <Image src={VantaLogo} alt="Vanta Logo" />
            <Image src={PolicyGeniusLogo} alt="Policy Genius Logo" />
            <Image src={SlackLogo} alt="Slack Logo" />
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};
